import { Component, Inject } from '@angular/core';
import { FormsModule, ReactiveFormsModule, UntypedFormControl, Validators } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';

@Component({
    selector: 'app-edit-link-attribute',
    templateUrl: './edit-link-attribute.component.html',
    styleUrls: ['./edit-link-attribute.component.scss'],
    imports: [MatCardModule, MatFormFieldModule, MatInputModule, FormsModule, ReactiveFormsModule, MatButtonModule]
})
export class EditLinkAttributeComponent {
    /**
     * Expression régulière vérifiant qu'il s'agit d'une Url où d'un chemin UNC Windows.
     */
    private linkRegex =
        /(^https?:\/\/(?:www\.)?[-a-zA-Z0-9@:%._\+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b(?:[-a-zA-Z0-9()@:%_\+.~#?&\/=]*)$)|(\\\\[a-zA-Z0-9\.\-_]{1,}(\\[a-zA-Z0-9\-_]{0,}){1,}[\$]{0,1})/;

    /**
     * Champs du formulaire de saisie du libellé du lien.
     */
    public labelFormControl = new UntypedFormControl(null, [Validators.required]);

    /**
     * Champs du formulaire de saisie de l'url du lien.
     */
    public urlFormControl = new UntypedFormControl(null, [Validators.required, Validators.pattern(this.linkRegex)]);

    /**
     * Données du lien.
     */
    public link: any;

    /**
     * Constructeur.
     * @param dialogRef
     * @param data
     */
    constructor(
        public dialogRef: MatDialogRef<EditLinkAttributeComponent>,
        @Inject(MAT_DIALOG_DATA) public data: string
    ) {
        if (data) {
            this.link = JSON.parse(data);
        } else {
            this.link = { displayName: '', url: '' };
        }
    }

    /**
     * Appelée lorsque l'utilisateur clique sur le bouton 'Annuler'.
     */
    public cancel(): void {
        this.dialogRef.close();
    }

    /**
     * Appelée lorsque l'utilisateur clique sur le bouton 'Valider'.
     */
    public validate(): void {
        if (this.labelFormControl.valid && this.urlFormControl.valid) {
            this.data = JSON.stringify(this.link);
            this.dialogRef.close(this.data);
        }
    }
}
